'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Flex = undefined;

var _src = require('./src');

Object.defineProperty(exports, 'Flex', {
  enumerable: true,
  get: function get() {
    return _src.Flex;
  }
});
Object.defineProperty(exports, 'Item', {
  enumerable: true,
  get: function get() {
    return _src.Item;
  }
});

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Flex: _src2.default, Item: _src2.default };
